module.exports = __webpack_public_path__ + "img/66.8cd4a9c3.png";